import * as React from 'react';

import {ErrorStateSmall} from 'shells/error-state/error-state-small';

import {CactusLoadingPage, CactusComingSoonPage} from '../empty-states';

type Props = {
    isLoading: boolean;
    isError: boolean;
    comingSoonText: string | null | undefined;
    content: React.ReactNode;
    banner?: React.ReactNode;
};

export function CardContent(props: Props) {
    const {isLoading, isError, comingSoonText, content, banner} = props;

    return (
        <>
            {comingSoonText ? <CactusComingSoonPage text={comingSoonText} /> : undefined}
            {isLoading && !comingSoonText ? <CactusLoadingPage /> : undefined}
            {isError ? (
                <div className='flex justify-center full-width pad-16'>
                    <ErrorStateSmall message='Something went wrong fetching your data' />
                </div>
            ) : undefined}
            {!isLoading && !isError && !comingSoonText ? (
                <div>
                    {banner}
                    {content}
                </div>
            ) : undefined}
        </>
    );
}
